import { createAction } from 'redux-act';

// get Branches action
const getAllBranchesRequest = createAction('GET_ALL_BRANCHES_REQUEST', data => data);
const getAllBranchesSuccess = createAction('GET_ALL_BRANCHES_SUCCESS', data => data);
const getAllBranchesError = createAction('GET_ALL_BRANCHES_ERROR');


// clear existing Branches action
const handleClearBranchesStore = createAction('HANDLE_CLEAR_BRANCHES_STORE',data => data);
// const toastMsgAction = createAction('SUCCESS', data=> data);

export default {
    getAllBranchesRequest,
    getAllBranchesSuccess,
    getAllBranchesError,
    
    handleClearBranchesStore,
    
}